export type GtagFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    gtag?: GtagFn;
    dataLayer?: unknown[];
  }
}

export const getGtag = (): GtagFn | null => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return null;
  }
  return window.gtag;
};
